// extracted by mini-css-extract-plugin
module.exports = {"root":"RichText-module--root--1noQX","content":"RichText-module--content--2VPy6"};